import { render, staticRenderFns } from "./VuesticFileUploadContainer.vue?vue&type=template&id=813b8bfa&"
import script from "./VuesticFileUploadContainer.vue?vue&type=script&lang=js&"
export * from "./VuesticFileUploadContainer.vue?vue&type=script&lang=js&"
import style0 from "./VuesticFileUploadContainer.vue?vue&type=style&index=0&id=813b8bfa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports